import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

interface Movement {
  id: number;
  data_movimento?: string;
  descricao?: string;
  tipo: "credito" | "debito";
  status: string;
  valor_cents?: number;
}

interface Props {
  movements: Movement[];
  formatCurrency: (v: number) => string;
}

function formatDateTime(value?: string) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function MovementsTable({ movements, formatCurrency }: Props) {
  return (
    <Table>
      <TableHeader>
        <TableRow className="bg-muted/50">
          <TableHead>Data</TableHead>
          <TableHead>Descrição</TableHead>
          <TableHead>Tipo</TableHead>
          <TableHead>Status</TableHead>
          <TableHead className="text-right">Valor</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {movements.length === 0 ? (
          <TableRow>
            <TableCell colSpan={5} className="py-8 text-center text-muted-foreground">
              Sem movimentações recentes
            </TableCell>
          </TableRow>
        ) : (
          movements.map((m) => (
            <TableRow key={m.id} className="transition-colors hover:bg-muted/30">
              <TableCell className="font-medium">{formatDateTime(m.data_movimento)}</TableCell>
              <TableCell>{m.descricao || "-"}</TableCell>
              <TableCell>
                <Badge
                  variant={m.tipo === "credito" ? "default" : "destructive"}
                  className={m.tipo === "credito" ? "bg-forest text-primary-foreground" : ""}
                >
                  {m.tipo === "credito" ? "Crédito" : "Débito"}
                </Badge>
              </TableCell>
              <TableCell>
                <Badge variant="secondary" className="bg-muted text-muted-foreground">
                  {m.status ? m.status.charAt(0).toUpperCase() + m.status.slice(1) : "-"}
                </Badge>
              </TableCell>
              <TableCell
                className={`text-right font-700 ${m.tipo === "debito" ? "text-destructive" : "text-forest"}`}
              >
                {m.tipo === "debito" ? "- " : ""}
                {formatCurrency(Number(m.valor_cents ?? 0))}
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}